module.exports = __webpack_public_path__ + "citizenship_test_icon.png?07dfdf1cee3a34921f91b08d98b7e556";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/citizenship_test_icon.png
// module id = 56
// module chunks = 0